import { Component, computed, inject, input, ViewChild } from '@angular/core';

import { routeParams, translate } from '../../../../../modules/shared/shared.global-service';
import { TableComponent } from '../../../../../modules/shared/components/kit/table/table.component';
import { TableColumn, TableColumnType } from '../../../../../modules/shared/components/kit/table/table.types';
import {
    userChipColumn,
    validFromColumn,
    validToColumn,
} from '../../../../../modules/shared/components/kit/table/table.fields';
import { ServiceDoctorsSecretsStore } from './service-doctors-secrets.store';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { ConfirmBuilder } from '../../../../../modules/shared/service/confirm.builder';
import { FilterInput } from '@it2go/data-grid';
import { TranslatePipe } from '@ngx-translate/core';
import { UserSecretsItemObject } from '@libs/types/src/user/object-type/user-secrets-grid.object';
import {
    ServiceDoctorsCertificatesModalComponent,
} from '../service-doctors-certificates-modal/service-doctors-certificates-modal.component';
import { UserSecretTypeEnum } from '@libs/types/src/user/enum/user-secret-type.enum';
import { BaseDialogService } from '../../../../kit/base-dialog/base-dialog-service';
import { CardTableComponent } from '../../../../../modules/shared/components/kit/table/card-table.component';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-service-doctors-secrets',
    imports: [TranslatePipe, CardTableComponent, PrimeTemplate],
    templateUrl: './service-doctors-secrets.component.html',
    styleUrl: './service-doctors-secrets.component.scss',
    providers: [ServiceDoctorsSecretsStore],
})
export class ServiceDoctorsSecretsComponent {
    public readonly store = inject(ServiceDoctorsSecretsStore);
    public readonly confirm = inject(ConfirmBuilder);
    public readonly dialogService = inject(BaseDialogService);

    public serviceId = input<number>(0);
    public secretType = input<UserSecretTypeEnum>(UserSecretTypeEnum.QUAL_CERT);
    public title = input<string>('');

    @ViewChild('doctorsCertificatesTable') private tableRef!: TableComponent;

    protected columns: TableColumn[] = [
        {
            name: 'valid',
            dataKey: null,
            data: (item: UserSecretsItemObject) => {
                const dateNow = new Date();
                const validFrom = item.validFrom
                    ? new Date(item.validFrom)
                    : null;
                const validTo = item.validTo ? new Date(item.validTo) : null;

                return validFrom && validTo
                    ? validFrom <= dateNow && validTo >= dateNow
                    : false;
            },
            type: TableColumnType.Active,
        },
        validFromColumn,
        validToColumn,
        {
            name: 'type',
        },
        userChipColumn,
    ];

    protected additionalFilters = computed<FilterInput[][]>(() => [
        [
            {
                column: 'serviceId',
                operator: 'EQ',
                value: [String(this.serviceId() || 0)],
            },
        ],
        [
            {
                column: 'type',
                operator: 'EQ',
                value: [this.secretType()],
            },
        ],
    ]);

    async refresh() {
        await this.tableRef.reload();
    }

    addSecret() {
        const ref = this.dialogService.open(
            ServiceDoctorsCertificatesModalComponent,
            {
                header: translate.instant(
                    'service.settings.eprescriptions.addSecret',
                ),
                data: {
                    serviceId: this.serviceId(),
                    secretType: this.secretType(),
                },
                styleClass: 'p-dialog-width-60',
            },
        );
        ref.onClose.subscribe(async (result) => {
            if (result) {
                this.refresh();
            }
        });
    }

    protected async deleteSecret(event: any) {
        this.confirm.confirmDelete(async () => {
            await this.store.api.deleteUserSecret({
                id: event.item.id,
            });
            this.refresh();
            contentGlobalSuccess.next('common.deleted');
        }, event);
    }

    protected readonly routeParams = routeParams;
    protected readonly Number = Number;
}
